import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FiChevronDown, FiFilePlus, FiPlus } from "react-icons/fi";
import FileUploader from "../../../components/FileUploader";

interface RunsDropdownProps {
  onCreateRun: () => void;
  onAddFiles: () => void;
}

const AddRunsDropdown: FC<RunsDropdownProps> = ({
  onCreateRun,
  onAddFiles,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDropdownToggle = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setDropdownOpen((prev) => !prev);
  }, []);

  const dropdownButton = useMemo(
    () => (
      <button
        type="button"
        className="relative w-full md:w-auto px-6 py-3 rounded-full text-white font-semibold border-none ring-2 ring-transparent overflow-hidden group transition-all duration-300 ease-in-out flex items-center justify-center"
        onClick={handleDropdownToggle}
      >
        <span className="absolute inset-0 bg-gradient-to-r from-custom-teal via-custom-purple to-custom-dark-purple transition-all duration-300 ease-in-out group-hover:bg-gradient-custom-hover" />
        <div className="relative z-10 flex items-center">
          <FiPlus className="mr-2 font-bold text-sm md:text-base" />
          <span className="font-bold text-sm md:text-base">Add</span>
          <FiChevronDown className="ml-2 font-bold text-sm md:text-base" />
        </div>
      </button>
    ),
    [handleDropdownToggle]
  );

  return (
    <div className="relative">
      {dropdownButton}
      {dropdownOpen && (
        <div
          className="absolute right-0 mt-2 min-w-[16rem] whitespace-nowrap bg-white border border-[#D9D8E1] rounded-lg shadow-xl overflow-hidden z-50"
          ref={dropdownRef}
        >
          <div className="py-2 w-auto">
            <div
              className="px-4 py-2 flex items-center space-x-3 text-[#48455B] hover:bg-gray-200 cursor-pointer transition-colors duration-150 mx-2"
              onClick={onCreateRun}
            >
              <FiPlus className="text-lg" />
              <span>Create a Run</span>
            </div>

            <div
              className="px-4 py-2 flex items-center space-x-3 text-[#48455B] hover:bg-gray-200 cursor-pointer transition-colors duration-150 mx-2"
              onClick={(e) => {
                onAddFiles();
                e.preventDefault();
              }}
            >
              <FiFilePlus className="text-lg" />
              <span>Add Files</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddRunsDropdown;
